var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGeschlosseneAnfrage = function SvgGeschlosseneAnfrage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.4 55.2",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.004)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "828-a",
    gradientUnits: "userSpaceOnUse",
    x1: -457.885,
    y1: 515.249,
    x2: -457.904,
    y2: 516.232,
    gradientTransform: "matrix(37.37 0 0 -37.1714 17139.27 19198.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c52cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b359e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.4 24.7 36.7 6h-18L9 24.7l1.2 5.2h1.9l2.3 11.6c0 .2.1.4.3.6.2.2.4.4.6.5.2.1.5.3.8.3.3.1.6.1.9.1h21.3c.3 0 .6 0 .9-.1.3-.1.5-.2.8-.3.2-.1.4-.3.6-.5.2-.2.3-.4.3-.6L43.2 30h1.9l1.3-5.3z",
    fill: "url(#828-a)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 0c.4 0 .7.1 1.1.2.3.1.6.3.8.5.2.2.4.5.5.7.1.3.1.6 0 .9L29 15.1c0 .2-.1.4-.3.6-.2.2-.4.4-.6.5-.2.1-.5.3-.8.3-.3.1-.6.1-.9.1H5.1c-.3 0-.6 0-.9-.1-.3-.1-.5-.2-.8-.3-.2-.1-.4-.2-.5-.5-.2-.2-.3-.4-.3-.6L0 2.4c0-.3 0-.6.1-.9.1-.3.3-.5.5-.7.2-.2.5-.4.8-.5.3-.2.7-.3 1.1-.3h26.7z",
    transform: "translate(11.887 26.402)",
    style: {
      fill: "#6c718e"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.487 26.483c.1 0 .2 0 .3.1.1 0 .1 0 .2.1h.1l.2.1h.1c.1 0 .2.1.3.2.1 0 .1.1.2.2l.2.2c.1.1.1.2.2.2l-8.4-15.1v-.1l-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1h-14.1v.2l-8 15.3c0-.1.1-.2.2-.2l.2-.2c.1-.1.2-.1.2-.2.1-.1.2-.1.3-.2.1 0 .2-.1.3-.1.1 0 .2-.1.3-.1.1 0 .2 0 .3-.1h27.2c-.2 0-.1.1.1.1z",
    fill: "#3c2e73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.13 29.258c.2 0 .4 0 .6.1.2.1.4.2.5.3.1.1.3.2.3.4.1.2.1.3.1.5s-.1.4-.2.5c-.1.2-.3.3-.4.4-.2.1-.4.2-.5.3-.2.1-.4.1-.6.1h-12.5c-.2 0-.4 0-.6-.1-.2 0-.4-.2-.6-.3-.2-.1-.3-.2-.4-.4-.1-.1-.2-.3-.2-.5s0-.4.1-.5c.1-.2.2-.3.3-.4.1-.1.3-.2.5-.3.2-.1.5-.1.7-.1h12.9z",
    fill: "#0a1343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 24.702-1.2 5.2h-35l-1.2-5.2h37.4z",
    fill: "#9da0b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.7 9.7 0h18l9.7 18.7H0z",
    transform: "translate(9 5.966)",
    style: {
      fill: "#6c718e"
    }
  }));
};
export default SvgGeschlosseneAnfrage;